
import NavItem from './components/navItem/index.jsx'
import TopImage from './components/topImage/index.jsx'
import TopImageCopy from './components/topImage/Copy.jsx'
import TopImageSide from './components/topImage/side.jsx'
import Suspension from './components/suspension/index.jsx'
import SuspensionSide from './components/suspension/side.jsx'
import SuspensionCopy from './components/suspension/copy.jsx'
import TopRotation from './components/topRotation/index.jsx'
import TopRotationSide from './components/topRotation/side.jsx'
import TopRotationCopy from './components/topRotation/Copye.jsx'
import BasicsText from './components/basicsText/index.jsx'
import BasicsTextSide from './components/basicsText/side.jsx'
import BasicsTextCopy from './components/basicsText/copy.jsx'
import ConversionOfficial from './components/conversionOfficial/index.jsx'
import ConversionOfficialSide from './components/conversionOfficial/side.jsx'
import ConversionOfficialCopy from './components/conversionOfficial/copy.jsx'
import NovelIfon from './components/novelIfon/index.jsx'
import NovelIfonSide from './components/novelIfon/side.jsx'
import NovelIfonCopy from './components/novelIfon/copy.jsx'
import React from 'react'
console.log(React)

export const datas = [{
  title: '组件',
  data: [{
    navComp: NavItem,
    navCopyComp: '',
    contentComp: TopImage,
    contentCopyComp: TopImageCopy,
    sideComp: TopImageSide,
    text: '图片',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='evenodd'><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-2.657 8.156a1 1 0 00-1.347.006l-4.22 3.881a.5.5 0 01-.643.03l-2.731-2.087a.25.25 0 00-.402.199V19.5a1 1 0 001 1h11a1 1 0 001-1v-1.82a.5.5 0 00-.165-.371zM11 9.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fill-rule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg>,
    ifon: {
      imageList: [],
      currentIndex: 0
    },
    type: '',
    name: 'image_comp'
  }, {
    navComp: NavItem,
    navCopyComp: '',
    contentComp: TopRotation,
    contentCopyComp: TopRotationCopy,
    sideComp: TopRotationSide,
    text: '轮播图',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stopColor='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fillRule='evenodd'><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-3.905 8.082l-.099.08-4.22 3.881a.5.5 0 01-.567.077l-.076-.048-2.731-2.086a.25.25 0 00-.395.142l-.007.057V19.5a1 1 0 00.883.993l.117.007h11a1 1 0 00.993-.883l.007-.117v-1.82a.5.5 0 00-.107-.31l-.058-.061-3.492-3.153a1 1 0 00-1.248-.074zM24 9a2 2 0 012 2v6a2 2 0 01-2 2h-1v-1.5h1a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-1V9h1zM5 9v1.5H4a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h1V19H4a2 2 0 01-2-2v-6a2 2 0 012-2h1zm6 .5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fillRule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg>,
    ifon: {
      image_id_list: [],
      currentIndex: 0,
      type: 0,
      playbackSpeed: 500,
      backType: 0,
      backImage: null,
      back: '#ffffff',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    type: '',
    name: 'carousel_comp'
  }, {
    navComp: NavItem,
    navCopyComp: '',
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '视频',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stopColor='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fillRule='evenodd'><path d='M16.5 8A1.5 1.5 0 0118 9.5v2.25l4.2-3.15a.5.5 0 01.8.4v10a.5.5 0 01-.8.4L18 16.25v2.25a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 015 18.5v-9A1.5 1.5 0 016.5 8h10z' fill='url(#a)' fillRule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg>,
    ifon: {

    },
    type: '',
    name: 'video_comp'
  }, {
    navComp: NavItem,
    navCopyComp: '',
    contentComp: BasicsText,
    contentCopyComp: BasicsTextCopy,
    sideComp: BasicsTextSide,
    text: '文本',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='canvas_gradient_common'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M8.5 6h11A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6zm1 3.5V11h9V9.5h-9zM12 17v1.5h4V17h-4zm-2.5-6v1.5h.75l.375-1.5H9.5zm9 0h-1.125l.375 1.5h.75V11zm-5.25 0v6h1.5v-6h-1.5z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {
      html: '',
      color: '#000000',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      isFrame: false,
      textStyle: 0,
      frameColor: '#000000',
      thickness: 4,
      fillet: 5,
      framePaddingTop: 0,
      framePaddingBottom: 0,
      framePaddingLeft: 0,
      framePaddingRight: 0
    },
    type: '',
    name: 'text_comp'
  }, {
    navComp: NavItem,
    navCopyComp: '',
    contentComp: Suspension,
    contentCopyComp: SuspensionCopy,
    sideComp: SuspensionSide,
    text: '关注公众号',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M21.5 7c1.38 0 2.5 1.343 2.5 3v8c0 1.657-1.12 3-2.5 3h-15C5.12 21 4 19.657 4 18v-8c0-1.657 1.12-3 2.5-3h15zM13 15h-1.75A1.75 1.75 0 1013 16.75V15zm3.75 0H15v1.75A1.75 1.75 0 1016.75 15zm-5.5-5.5a1.75 1.75 0 000 3.5H13v-1.75a1.75 1.75 0 00-1.75-1.75zm5.5 0A1.75 1.75 0 0015 11.25V13h1.75a1.75 1.75 0 000-3.5z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {
      officialAccount: '',
      card: 0,
      cardStyle: {
        card1: {
          headPortrait: {},
          text: '关注',
          accountName: '',
          accountDescription: ''
        },
        card2: {
          text: '',
          height: 40
        },
        card3: {
          describe1: '长按保存二维码到相册 关注获取更多内容',
          describe2: '',
          color: '#ccc',
          fontSize: 14
        },
        card4: {
          backImage: {}
        }
      },
      attentionMode: [],
      officialAccountLink: '',
      cardColor: '#ffffff',
      cardBackColor: '#1890ff',
      cardBackColor1: '#ffffff',
      fontSize: 14,
      width: 90,
      fillet: 4,
      layout: 1,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      isSuspension: false,
      bottomDistance: 0,
      message: 40,
      isGuide: true,
      floatingLayer: false
    },
    type: '',
    name: 'officialAccount_comp'
  }, {
    navComp: NavItem,
    navCopyComp: '',
    contentComp: ConversionOfficial,
    contentCopyComp: ConversionOfficialCopy,
    sideComp: ConversionOfficialSide,
    text: '按钮',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M21 7a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h14zm-4.857 2a2.857 2.857 0 00-2.857 2.857v4.286a1.429 1.429 0 11-1.429-1.429v-1.428a2.857 2.857 0 102.857 2.857v-4.286a1.429 1.429 0 111.429 1.429v1.428a2.857 2.857 0 100-5.714z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {
      link: '',
      text: '',
      color: '#ffffff',
      colorBack: '#1890ff',
      fontSize: 16,
      width: 90,
      height: 40,
      fillet: 4,
      layout: 1,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      isSuspension: false,
      bottomDistance: 0,
      message: 0
    },
    type: '',
    name: 'button_comp'
  }, {
    navComp: NavItem,
    navCopyComp: '',
    contentComp: NovelIfon,
    contentCopyComp: NovelIfonCopy,
    sideComp: NovelIfonSide,
    text: '小说信息',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M20.5 7A2.5 2.5 0 0123 9.5v8a2.5 2.5 0 01-2.5 2.5h-13A2.5 2.5 0 015 17.5v-8A2.5 2.5 0 017.5 7h13zm-.75 6.25h-5.5a.25.25 0 00-.25.25v1c0 .138.112.25.25.25h5.5a.25.25 0 00.25-.25v-1a.25.25 0 00-.25-.25zM9.5 10a2 2 0 100 4 2 2 0 000-4zm10.25-.5h-5.5a.25.25 0 00-.25.25v1c0 .138.112.25.25.25h5.5a.25.25 0 00.25-.25v-1a.25.25 0 00-.25-.25z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {
      image: {},
      color: '#000000',
      html: ''
    },
    type: '',
    name: 'novelIfon_comp'
  }]
}]
